
export { DataCatalogType } from "/home/runner/work/eon-service/eon-service/frontend/packages/api-gw-sdk/dist/models/DataCatalogType.js"